import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  CancelAppointments,

} from "./DataServices/AppointmentsDataServices";

const CancelMainAppointment: React.FC = () => {
  const { mainAppointmentId } = useParams<{ mainAppointmentId: string }>();
  const [status, setStatus] = useState<string>("");
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const cancelAppointment = async () => {
    try {
      if (!mainAppointmentId) {
        throw new Error("mainAppointmentId is undefined");
      }
      await CancelAppointments([mainAppointmentId], true);

      setStatus("✅ Appointment successfully cancelled.");
    } catch (err) {
      setStatus("⚠️ An error occurred. Please try again later.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Arial",
      }}
    >
      <div
        style={{
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          textAlign: "center",
          width: "300px",
          backgroundColor: "#fff",
        }}
      >
        {!confirmed ? (
          <>
            <h3>Are you sure you want to cancel the appointment?</h3>
            <button
              style={{
                marginTop: "15px",
                padding: "10px 20px",
                backgroundColor: "#d9534f",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                cancelAppointment();
                setConfirmed(true);
              }}
            >
              ❌ Cancel Appointment
            </button>
          </>
        ) : (
          <p>{status}</p>
        )}
      </div>
    </div>
  );
};

export default CancelMainAppointment;
